import { Grid, GridSpacing } from '@mui/material';
import React, { CSSProperties } from 'react';
import { useTheme } from '@mui/material/styles';
import { RenderChildren } from '@/node-editor/components';
import { getSpacerValue } from '@/lib/utils/format';
import { INode, INodeProps } from '@/types/node';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { RowContextProvider } from './context';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
  override: {
    root: CSSProperties;
  };
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

export const Render = ({
  node: {
    id,
    content: { alignment, horizontalSpacing = '1', verticalSpacing },
    override,
  },
  children,
}: IProps) => {
  const theme = useTheme();
  const spacing = parseInt(horizontalSpacing, 10) as GridSpacing;

  const containerStyles = {
    width: '100%',
    justifyContent: alignment.horizontal,
    alignItems: alignment.vertical,
    paddingTop: theme.spacing(getSpacerValue(verticalSpacing.top)),
    paddingBottom: theme.spacing(getSpacerValue(verticalSpacing.bottom)),
    margin: 0,
    paddingLeft: parseInt(horizontalSpacing, 10) / 2,
    paddingRight: parseInt(horizontalSpacing, 10) / 2,
    ...override.root,
  };
  return (
    <Grid
      container
      columns={12}
      spacing={spacing}
      sx={containerStyles}
      {...useNodeProps(id)}
    >
      <RowContextProvider horizontalSpacing={parseInt(horizontalSpacing, 10)}>
        <RenderChildren>{children}</RenderChildren>
      </RowContextProvider>
    </Grid>
  );
};
